import { render, staticRenderFns } from "./UserDetailLecture.vue?vue&type=template&id=1fedd471&"
import script from "./UserDetailLecture.vue?vue&type=script&lang=ts&"
export * from "./UserDetailLecture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports